import React from 'react';
import loadingGif from '../assets/icons/loading.gif';

export default function Spinner() {
  return (
    <div className='map-panel-loading-container'>
        <img className='map-panel-loading-gif' src={loadingGif}/>
    </div>
  )
}